// Shared bits of the transcript format used by both Localization entry points — creating a set and
// appending conversations to one. The server owns the actual rules; these are the client-side hints.

export const FORMAT_EXAMPLE = `user: Ich kann mich nicht einloggen
assistant: Hast du dein Passwort zurückgesetzt?
user: Das hat nicht funktioniert

Wo ist meine Auszahlung?`;

// countBlocks is a hint for the dialogs, not a parse: the server owns the format rules and is the
// only thing that decides whether the text is valid.
export const countBlocks = (text) => text
  .split(/\n\s*\n/)
  .map((block) => block.trim())
  .filter(Boolean).length;
